import React from 'react'
import { WContainer, Breadcrumbs, MainTitle } from '@next-nx/shared-ui/atoms'
import { Page } from '@next-nx/shared-ui/organisms'
import { PlaceholderReact } from '@next-nx/shared-ui/molecules'
import styles from './CatchAllTemplate.module.sass'


interface Props {
  pagina?: any
  withPlaceholder?: boolean
  defaultContent?: any
}

const CatchAllTemplate = (props: Props) => {
  const { pagina = null, withPlaceholder = false, defaultContent = null } = props

  return (
    <Page pagina={pagina} item={{}}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina?.breadcrumbs} />
        <div className={styles.headLayout}>
          <div className={styles.headContent}>
            <MainTitle label={pagina?.titolo} className={styles.title} />
          </div>
        </div>
      </WContainer>
      {withPlaceholder && (
        <div className={styles.contentSection}>
          <WContainer>
            <PlaceholderReact
              contentTypeId={pagina.model}
              objectId={pagina.pk}
              pkey="content"
              serverSideContent={defaultContent}
            />
          </WContainer>
        </div>
      )}
    </Page>
  )
}

export default CatchAllTemplate
